import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@helsenorge/designsystem-react/components/Button';
import Title from '@helsenorge/designsystem-react/components/Title';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import SafeHTML from '@helsenorge/framework-utils/components/safe-html';
import { getResources } from './resources';
import { HNeventShowCookieBanner } from '../cookie-banner/events';
import { useLanguage } from '../shared/language';
import cmsstyles from './styles.module.scss';
const VideoCookieBanner = props => {
    const { language } = useLanguage(LanguageLocales.NORWEGIAN);
    const defaultResources = getResources(language);
    const resources = { ...defaultResources, ...props.resources };
    return (_jsxs("div", { className: cmsstyles['tos-overlay'], children: [props.title && (_jsx(Title, { className: cmsstyles['tos-overlay__title'], htmlMarkup: "h2", appearance: "title3", children: props.title })), _jsxs("div", { className: cmsstyles['tos'], children: [_jsx(Title, { htmlMarkup: "h2", appearance: "title3", children: resources.cookie_consent_title }), _jsx(SafeHTML, { html: resources.cookie_consent_description, className: cmsstyles.tos__text }), _jsx(Button, { onClick: () => HNeventShowCookieBanner(props.onChange), children: resources.cookie_consent_button })] })] }));
};
export default VideoCookieBanner;
